import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Inspection } from '../../shared/interfaces';
import { InspectionService } from '../inspection.service';

@Component({
  selector: 'app-add-date-inspection',
  templateUrl: './add.date.component.html',
})
export class InspectionAddDateComponent implements OnInit {
  @ViewChild('addDateModal', { static: true }) public addDateModal: ModalDirective;

  confirmCallback: () => void;
  cancelCallback: () => void;
  inspection: Inspection;

  addDateForm: UntypedFormGroup;

  dateConfig = { dateInputFormat: 'MM-DD-YYYY', customTodayClass: 'date-today' };

  saving = false;
  loading = false;
  constructor(
    public inspectionService: InspectionService,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.addDateForm = this.fb.group({ dueDate: '' });

    this.addDateModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  show(options: { confirmed?: () => void; canceled?: () => void; inspection: Inspection }) {
    this.loading = true;
    this.cdr.markForCheck();

    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.inspection = options.inspection;

    if (this.inspection.dueDate) {
      this.addDateForm.controls.dueDate.setValue(this.inspection.dueDate);
    } else {
      this.addDateForm.setValue({
        dueDate: '',
      });
    }
    this.addDateModal.show();
    setTimeout(() => {
      this.loading = false;
      this.cdr.markForCheck();
    }, 100);
  }

  async save() {
    if (this.saving) return;

    if (this.addDateForm.valid) {
      this.saving = true;
      await this.inspectionService.addDate(this.inspection.id, this.addDateForm.value);
      this.addDateModal.hide();
      this.saving = false;
      return this.confirmCallback && this.confirmCallback();
    }
  }

  cancel() {
    this.addDateModal.hide();
    return !!this.cancelCallback && this.cancelCallback();
  }
}
